"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "hash": "eb8fe0c",
    "raw": "v2.30.1",
    "semverString": "2.30.1"
};
//# sourceMappingURL=version.js.map